<template>
    <module-section>
        <div class="container">
            <h3>Visa Application</h3>
            <section class="l">
                <p>Q：Do I need to do anything for staying in China legally？</p>
                <p>A: Yes definitely. Students studying in China for more than 6 months with student visa (or X Visa) must apply for a Residence Permit within the first 30 days of arrival.</p>
            </section>
            <section class="r">
                <p>In order to apply for resident permit, first of all, you need to prepare the following documents and submit them to supervisor’s office so they can help you to make appointment online:</p>
                <p>1. Payment receipt of tuition fees and accommodation fees (not required for Scholarship Students).</p>
                <p>2. Payment receipt of Medical Insurance.</p>
                <p>3. Payment receipt of registration fee</p>
            </section>
        </div>
    </module-section>
</template>

<script>
import ModuleSection from './ModuleSection.vue'

export default {
  components: {
    ModuleSection
  },
}
  </script>

<style lang="scss" scoped>
$primaryColor: #b1040e;

.container {
    position: relative;
    height: 500px;
}
h3 {
    font-size: 48px;
}
.l,
.r {
    position: absolute;
    font-size: 20px;
    font-weight: 700;
    padding: 12px;
    width: 700px;
    border: 4px solid transparent;
    p {
        margin-bottom: 12px;
    }
}
.l {
    border-color: #333;
    top: 80px;
    left: 0;
}
.r {
    border-color: transparent;
    position: absolute;
    top: 210px;
    right: 0;
    color: #fff;
    background-color: $primaryColor;
}
</style>
